import React from 'react';

const SolutionSection = ({ data }) => {
  return (
    <section className="p-80px-tb solution-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <h3 className="h4 text-primary m-30px-b">{data.subtitle}</h3>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-6 m-30px-b">
            {/* AI アシスタントとの対話画面 */}
            <div className="solution-visual-placeholder">
              <img
                src={process.env.PUBLIC_URL + "/assets/img/ss3.png"}
                alt="AIアシスタントとの対話画面"
                className="img-fluid rounded"
                style={{width: '100%', height: 'auto'}}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <p className="lead m-25px-b">{data.content}</p>
            <div className="alert alert-primary p-30px m-30px-b">
              <h4 className="alert-heading font-weight-bold">{data.highlight}</h4>
            </div>
            <p className="text-muted">{data.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;